// src/components/SidebarLegal.tsx
import Link from "next/link";

export default function SidebarLegal() {
  return (
    <div className="mt-auto px-4 py-3 border-t text-[11px] text-gray-500 space-x-3">
      <Link href="/faq" className="hover:underline">FAQ</Link>
      <Link href="/pricing" className="hover:underline">料金</Link>
      <Link href="/terms" className="hover:underline">利用規約</Link>
      <Link href="/privacy" className="hover:underline">プライバシー</Link>
      <Link href="/support" className="text-xs text-gray-700 hover:underline font-medium">お問い合わせ</Link>
    </div>
  );
}
